module.exports = __webpack_public_path__ + "img/MPP.21c2a46f.png";